import { render, staticRenderFns } from "./UpsellsItem.vue?vue&type=template&id=0c00f63c"
import script from "./UpsellsItem.vue?vue&type=script&lang=js"
export * from "./UpsellsItem.vue?vue&type=script&lang=js"
import style0 from "./UpsellsItem.vue?vue&type=style&index=0&id=0c00f63c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports